import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import '@angular/common/locales/global/pl';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PowerPipe } from './power.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbTooltipModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pl' },
    PowerPipe
  ],
  declarations: [
    PowerPipe
  ],
  exports: [
    PowerPipe
  ]
})
export class SharedApplicationModule { }
